export default {
  GET_MENU_LIST:'GET_MENU_LIST'
}



// WEBPACK FOOTER //
// ./src/store/constant.js